import { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { ITaskResponse, taskSearch, ITaskSearchParam, findNotesByTaskIds } from 'wisestep-api';

import { useConversationWidgetStore } from '../../../utils/useConversationWidgetStore';

const useTaskSearch = (
  query: ITaskSearchParam,
  setLoader: Dispatch<SetStateAction<boolean>>
): [ITaskResponse[], number] => {
  const [taskList, setTaskList] = useState<ITaskResponse[]>([]);
  const taskFilterJobId = useConversationWidgetStore((state) => state.taskFilterJobId);
  const [totalsTasks, setCount] = useState(0);
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setLoader(true);
        if (taskFilterJobId && query.taskAttributes) {
          query.taskAttributes.jobCode = [taskFilterJobId];
        }
        const response = await taskSearch(query);
        const tasks = response.data;
        const taskIds = tasks.map((task) => task.id);
        const clientInfoMap = await findNotesByTaskIds(taskIds);
        const clientInfoByTaskId = {};
        clientInfoMap.data.forEach((item) => {
          clientInfoByTaskId[item.taskId] = item;
        });
        const enrichedTasks = tasks.map((task) => {
          const info = clientInfoByTaskId[task.id] || {};
          const client = info.client || {};
          const clientContact = info.clientContact || {};
          return {
            ...task,
            clientName: client.name || '',
            clientId: client.id ?? '',
            parentId: client.parentId ?? '',
            parentName: client.parentName ?? '',
            contactId: clientContact.id ?? '',
            contactName: clientContact.firstName
              ? `${clientContact.firstName} ${clientContact.lastName || ''}`.trim()
              : '',
          };
        });
        setTaskList(enrichedTasks);
        setLoader(false);
        setCount(Number(response.headers['x-total-count']));
      } catch (e) {
        setLoader(false);
      }
    };

    fetchJobs();
  }, [query, setLoader, taskFilterJobId]);

  return [taskList, totalsTasks];
};

export default useTaskSearch;
